/**
 * @description Transforma la primera letra a mayuscula
 *
 * @author andres.martinez, Hábil MX
 * @param p palabra en minúsculas o mayúsculas
 * @returns palabra con inicial en mayúscula
 */
export const capitalInicial = (p: string) => {
  return p[0].toUpperCase() + p.substring(1).toLowerCase()
}

/**
 * @description Transforma una palabra a mayusculas
 *
 * @author andres.martinez, Hábil MX
 * @param p palabra en minúsculas o mayúsculas
 * @returns palabra en mayúsculas
 */
export const capital = (p: string) => {
  return p.substring(0).toUpperCase()
}
